import firebase from "firebase/app";
import "firebase/auth";

export default async client => {
    firebase.auth().onAuthStateChanged(async user => {
        if (user)
            client.writeData({
                data: { myId: user.id || null, myUID: user.uid, loggedIn: true, loading: false }
            });
        else client.writeData({ data: { loggedIn: false, loading: false } });
    });
    return;
};
